export default "__VITE_ASSET__CLNyrLEo__"